import Cookies from "js-cookie";

export const setCookie = (cname, cvalue) => {
  Cookies.set(cname, cvalue);
};

export const removeAllCookies = () => {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    Cookies.remove(cookieName);
  });
};
export const getCookie = (cname) => Cookies.get(cname);

export const getCookieJSON = (cname) => {
  return Cookies.getJSON(cname);
};

export const removeCookie = (cname) => {
  Cookies.remove(cname);
};

export const setLocalStorage = (cname, cvalue) => {
  try {
    localStorage.setItem(cname, cvalue);
  } catch (error) {
    console.error('Error setting localStorage item:', error);
  }
};

export const setLocalStorageJSON = (cname, cvalue) => {
  localStorage.setItem(cname, JSON.stringify(cvalue));
};

export const removeLocalStorage = (cname) => {
  localStorage.removeItem(cname);
};
export const getLocalStorageItem = (cname) => localStorage.getItem(cname);

export const getJSONLocalStorage = (cname) =>
  JSON.parse(localStorage.getItem(cname));

export const getLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error('Error getting localStorage item:', error);
    return null;
  }
};
